import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';
import BaseWrapper from '../components/BaseWrapper';

import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';
import Support from './Support';

function App() {
  return (
    <Router>
      <main>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/support">
            <Support />
          </Route>
          <Route path="/privacy-policy">
            <PrivacyPolicy />
          </Route>
        </Switch>
      </main>
      <BaseWrapper>
        <br />
        <br />
        <footer>&copy; 2021 Robert Piosik</footer>
        <br />
      </BaseWrapper>
    </Router>
  );
}

const app = () => <App />;

export default app;
